export const NOTIFICATION = 'NOTIFICATION'